export const OfficeFileImporterState = {
	url: '/file-import',
	title: 'Office File Importer',
	template: '<office-file-import></office-file-import>',
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "officeFileImporterCmpMod" */
			'@Containers/office-file-importer/office-file-importer.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
